import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import DashboardHeader from "../components/DashboardHeader";
import SidebarAdmin from "../components/SidebarAdmin";
import SidebarHRMCRM from "../components/SidebarHRMCRM";
import { useAuth } from "../context/AuthContext";
import "../assets/css/Admindashboard.css";

export default function DashboardLayout() {
  const { user } = useAuth();
  const location = useLocation();

const isAdminSection =
  location.pathname.startsWith("/dashboard/admin") ||
  location.pathname.startsWith("/dashboard/loans");

  
  const [sidebarOpen, setSidebarOpen] = useState(
  window.innerWidth >= 1024
);
  const [isMobile, setIsMobile] = useState(false);

  /* =========================
     AUTH SAFETY
  ========================= */
  if (!user) return <Navigate to="/login" replace />;

  /* =========================
     RESPONSIVE HANDLER
  ========================= */
useEffect(() => {
  const handleResize = () => {
    const mobile = window.innerWidth < 1024;
    setIsMobile(mobile);

    // Only auto-close on mobile
    if (mobile) {
      setSidebarOpen(false);
    }
  };

  handleResize();
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  return (
    <div
      className={`dashboard-layout
        ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}
        ${isMobile ? "is-mobile" : ""}
      `}
    >
      {/* ================= SIDEBAR ================= */}
  <aside className="dashboard-sidebar">
  {isAdminSection ? <SidebarAdmin /> : <SidebarHRMCRM />}
</aside>

      {/* ================= MOBILE OVERLAY ================= */}
      {isMobile && sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* ================= MAIN CONTENT ================= */}
      <div className="dashboard-main">
        <DashboardHeader
          title={
            isAdminSection
              ? "Admin Portal"
              : "HRM / CRM"
          }
          onToggleSidebar={() => setSidebarOpen((v) => !v)}
        />

        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
